import { makeLocalStorageAdapter } from "../factories/cache";
import { AccountModel } from "../../domain/models";

export const setCurrentAccountAdapter = (
  account: AccountModel | undefined
): void => {
  makeLocalStorageAdapter().set("account", account);
};

export const getCurrentAccountAdapter = (): AccountModel => {
  return makeLocalStorageAdapter().get("account");
};

export const setCurrentWarehouseAdapter = (warehouse: {
  id: number;
  name: string;
}): void => {
  makeLocalStorageAdapter().set("currentWarehouse", warehouse);
};

export const getCurrentWarehouseAdapter = (): { id: number; name: string } => {
  return makeLocalStorageAdapter().get("currentWarehouse");
};
